const organizations = {
    title: 'Organizasyonlar',
    description: 'Üyesi olduğunuz organizasyonları oluşturun ve yönetin.',
    create: 'Organizasyon oluştur',
    create_title: 'Yeni organizasyon oluştur',
    name: 'Organizasyon adı',
    avatar: 'Organizasyon avatarı',
    avatar_removed: 'Organizasyon avatarı kaldırıldı.',
    description_label: 'Açıklama',
    empty: 'Henüz bir organizasyona üye değilsiniz.',
    pending_invitations: 'Bekleyen davetler',
    accept: 'Kabul et',
    decline: 'Reddet',
    owner: 'Sahip',
    tabs: {
        overview: 'Genel bakış',
        members: 'Üyeler',
        invitations: 'Davetler',
        roles: 'Yönetim rolleri',
        branding: 'Marka',
        security: 'Güvenlik',
        jit: 'JIT sağlama',
        applications: 'Paylaşılan kaynaklar',
        activity: 'Etkinlik',
        deletion: 'Sil',
    },
    members: {
        title: 'Üyeler',
        empty: 'Üye bulunamadı.',
        remove: 'Kaldır',
        removed: 'Üye kaldırıldı.',
        business_roles: 'İş rolleri',
        no_business_roles: 'Kullanılabilir iş rolü yok. Kiracı yöneticinizden bu organizasyonla rol paylaşmasını isteyin.',
    },
    invitations: {
        title: 'Davetler',
        invite: 'Üye davet et',
        email: 'E-posta adresi',
        empty: 'Davet bulunamadı.',
        resend: 'Yeniden gönder',
        resent: 'Davet yeniden gönderildi.',
        revoke: 'İptal et',
        revoked: 'Davet iptal edildi.',
        status: {
            Pending: 'Bekliyor',
            Accepted: 'Kabul edildi',
            Expired: 'Süresi doldu',
            Revoked: 'İptal edildi',
            Declined: 'Reddedildi',
        },
    },
    roles: {
        title: 'Yönetim rolleri',
        create: 'Rol oluştur',
        permissions: 'İzinler',
        empty: 'Yönetim rolü bulunamadı.',
        select_member: 'Üye seç',
        select_role: 'Rol seç',
        assign: 'Rol ata',
        assigned: 'Rol atandı.',
        unassign: 'Rolü kaldır',
        unassigned: 'Rol kaldırıldı.',
        permission_count: 'İzinler: {{count}}',
        built_in: {
            owner: 'Sahip',
            owner_description: 'Organizasyon sahipleri, sahiplik yönetimi ve organizasyonu silme konusunda özel yetkilere sahiptir.',
            administrator: 'Yönetici',
            administrator_description: 'Sahiplere ayrılmış işlemler dışında organizasyonu yönetir.',
        },
        permission_labels: {
            update_profile: 'Profili güncelle',
            manage_branding: 'Markayı yönet',
            view_members: 'Üyeleri görüntüle',
            manage_members: 'Üyeleri yönet',
            manage_invitations: 'Davetleri yönet',
            assign_business_roles: 'İş rolleri ata',
            manage_management_roles: 'Yönetim rollerini yönet',
            assign_management_roles: 'Yönetim rolleri ata',
            manage_security: 'Güvenliği yönet',
            manage_jit: 'JIT sağlamayı yönet',
            manage_applications: 'Uygulamaları yönet',
            view_activity: 'Etkinliği görüntüle',
        },
    },
    branding: {
        title: 'Organizasyon markası',
        primary_color: 'Ana renk',
        custom_css: 'Özel CSS',
        preview: 'Önizleme',
        light: 'Açık',
        dark: 'Koyu',
    },
    security: {
        title: 'Organizasyon güvenliği',
        require_mfa: 'Üyeler için çok faktörlü kimlik doğrulamayı zorunlu kıl',
    },
    jit: {
        title: 'JIT e-posta alan adları',
        domain: 'E-posta alan adı',
        add: 'Alan adı ekle',
        verify: 'DNS kontrolü',
        dns_instruction: '{{value}} değeriyle {{record}} TXT kaydını oluşturun.',
        verified: 'Doğrulandı',
    },
    applications: {
        title: 'Paylaşılan kaynaklar',
        empty: 'Bu organizasyon için kullanılabilir kaynak yok.',
        sso: 'Kurumsal SSO bağlantıları',
        m2m: 'Makineler arası uygulamalar',
    },
    activity: {
        title: 'Organizasyon etkinliği',
        empty: 'Henüz etkinlik yok.',
        events: {
            create: 'Organizasyon oluşturuldu',
            delete: 'Organizasyon silindi',
            profile: 'Organizasyon profili güncellendi',
            branding: 'Organizasyon markası güncellendi',
            security: 'Organizasyon güvenliği güncellendi',
            member_add: 'Üye eklendi',
            member_remove: 'Üye kaldırıldı',
            owner: 'Organizasyon sahipliği güncellendi',
            role_create: 'Yönetim rolü oluşturuldu',
            role_update: 'Yönetim rolü güncellendi',
            role_delete: 'Yönetim rolü silindi',
            role_assign: 'Yönetim rolü atandı',
            role_unassign: 'Üyenin yönetim rolü kaldırıldı',
            business_role: 'İş rolleri güncellendi',
            invitation_create: 'Davet gönderildi',
            invitation_accept: 'Davet kabul edildi',
            invitation_decline: 'Davet reddedildi',
            invitation_revoke: 'Davet iptal edildi',
            jit: 'JIT sağlama güncellendi',
            domain: 'E-posta alan adı doğrulaması',
            application: 'Uygulama bağlantıları güncellendi',
            unknown: 'Organizasyon etkinliği',
        },
    },
    save: 'Değişiklikleri kaydet',
    cancel: 'İptal',
    delete: 'Organizasyonu sil',
    delete_confirmation: 'Organizasyon ve üyelikleri kalıcı olarak silinecek. Onaylamak için “{{name}}” yazın.',
    deleted: 'Organizasyon silindi.',
    load_failed: 'Organizasyon verileri yüklenemedi. Yeniden deneyin.',
    permission_denied: 'Bu bölümü görüntüleme izniniz yok.',
};
export default organizations;
